$(document).on('ready', function(){

    let elem = document.getElementById('sciencetab-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    var flkty = new Flickity( elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });
});


// Step By Step

$(document).on('ready', function(){

    let elem = document.getElementById('step-carousel');
    let width = $(window).width();
    let align = 'center';
    if (width > 992) {
        align = 'left';
    }
    var flkty = new Flickity( elem, {
        // options
        cellAlign: align,
        contains: false,
        freeScroll: false,
        prevNextButtons: false,
        pageDots: true,
        percentPosition: true
    });
});